import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  Schedule,
  ContentFixedSchedule,
  ContentShiftSchedule,
  AddShift,
  EditShift,
  DetailSchedule,
  EditDetailSchedule,
  ImportContentShiftSchedule,
} from "./pages";

const scheduleRoutes = [
  {
    path: "/presence/work-schedule",
    element: (
      <ProtectedRoute name="work_schedule">
        <Schedule />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"schedule.work_schedule"} />,
    children: [
      {
        path: "/presence/work-schedule/fixed-schedule",
        element: <ContentFixedSchedule />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"schedule.fixed_schedule"} />
        ),
      },
      {
        path: "/presence/work-schedule/shift-schedule",
        element: <ContentShiftSchedule />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"schedule.shift_schedule"} />
        ),
        children: [
          {
            path: "/presence/work-schedule/shift-schedule/add-shift",
            element: <AddShift />,
            breadcrumb: null,
          },
          {
            path: "/presence/work-schedule/shift-schedule/shift/:idShift",
            element: <EditShift />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
  {
    path: "/presence/work-schedule/shift-schedule/import",
    element: (
      <ProtectedRoute name="work_schedule_add">
        <ImportContentShiftSchedule />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"schedule.import_shift_schedule"} />
    ),
  },
  {
    path: "/presence/work-schedule/detail/:id",
    element: (
      <ProtectedRoute name="work_schedule">
        <DetailSchedule />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"schedule.detail"} />,
    children: [
      {
        path: "/presence/work-schedule/detail/:id/schedule/:idSchedule",
        element: <EditDetailSchedule />,
        breadcrumb: null,
      },
    ],
  },
];

export default scheduleRoutes;
